import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { FlexContainerVertical } from '../../../../../../layout/Flex';

const BigEmoji = styled('div')((p) => ({
  fontSize: 66,
  height: 66,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

export const DoneCelebration: React.FC<{ title: React.ReactNode }> = ({
  title,
  children
}) => {
  return (
    <FlexContainerVertical
      fullWidth
      alignItems="center"
      spacing={1.5}
      marginTop={4}
      marginBottom={4}
    >
      <BigEmoji>🎉</BigEmoji>
      <Typography variant="caption">
        <Typography variant="h4">{title}</Typography>
      </Typography>
      <Typography variant="caption">
        <FlexContainerVertical alignItems={'center'} fullWidth spacing={0}>
          {children}
        </FlexContainerVertical>
      </Typography>
    </FlexContainerVertical>
  );
};
